// MODULES
import React from "react";

// HELPERS
import {createClassName, getPropertiesByPrefix, parseDraftDataPropsToFieldState, delay} from "@helpers/utils";
import fulfillmentCheck from "./KycPrivatperson.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import OptionsList from "../../../components/OptionsList/OptionsList";
import EditableField from "../../../components/EditableField/EditableField";

export default class KycPrivatperson extends React.PureComponent {
	static companyExclusive = false;
	static privateExclusive = true;

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}

    if (prevProps.draftData !== props.draftData) {
      if (props.draftData) {
        const draftDataProps = getPropertiesByPrefix(props.draftData, ['futur_kyc_privat_', 'radio_customer_']);
        const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);
        
        this.setState(
          {
            fields: {...newFieldsState}
          },
          async () => {          
              await delay(200);
              onChange(id, {...this.state}, fulfillmentCheck(this.props, this.state));
          }
        );
      }
		}
	}

	render() {
		const {props, state} = this;
		const {title} = props;

		const classes = createClassName("Cob-Fees", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		const checkedSources = [];
		state.fields.futur_kyc_privat_source.options.forEach(function (o) {
			if (o.checked) {
				checkedSources.push(o.value);
			}
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<h4 style={{fontWeight: "600", marginBottom: "10px"}}>
						Varifrån kommer inbetalningarna till försäkringen?
					</h4>

					<OptionsList
						type="checkbox"
						orientation="vertical"
						name="futur_kyc_privat_source"
						options={state.fields.futur_kyc_privat_source.options}
						onChange={this._onOptionsListChange}
					/>

					<input type="hidden" name="futur_kyc_privat_source" value={checkedSources.join(",")}/>

					{state.fields.futur_kyc_privat_source.options[5].checked && (
						<EditableField
							name="futur_kyc_privat_source_other"
							label="Ange"
							value={state.fields.futur_kyc_privat_source_other}
							valid={state.validFields.futur_kyc_privat_source_other}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							style={{marginTop: "10px", maxWidth: "300px"}}
						/>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Har försäkringstagaren skattehemvist i annat land än Sverige?"}
						name="futur_kyc_privat_is_foreign"
						options={state.fields.futur_kyc_privat_is_foreign.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					<h3 style={{marginBottom: "0", marginTop: "40px"}}>
						PEP - Politiskt exponerad person
					</h3>

					<p>
						PEP – Person i politiskt utsatt ställning – Person som har eller tidigare har haft en hög
						politisk post, en hög statlig befattning eller funktion i ledningen i en internationell
						organisation, eller har en nära familjemedlem eller medarbetare med ovanstående befattning.
					</p>

					<OptionsList
						type="radio"
						orientation="horizontal"
						name="radio_customer_pep"
						description="Är försäkringstagaren själv, eller har varit, en politiskt exponerad person/politiskt utsatt person?"
						options={state.fields.radio_customer_pep.options}
						onChange={this._onOptionsListChange}
					/>

					<h3 style={{marginBottom: "0", marginTop: "40px"}}>
						FATCA
					</h3>

					<p>
						U.S. person – Person som har ett Amerikanskt medborgarskap eller på annat sätt är skatteskyldig
						i USA.
					</p>

					<OptionsList
						type="radio"
						orientation="horizontal"
						name="radio_customer_fatca"
						description="Är försäkringstagaren en så kallad U.S. person?"
						options={state.fields.radio_customer_fatca.options}
						onChange={this._onOptionsListChange}
					/>

					{state.fields.radio_customer_fatca.options[1].checked && (
						<EditableField
							name="futur_kyc_privat_us_tin"
							label="Ange TIN"
							value={state.fields.futur_kyc_privat_us_tin}
							valid={state.validFields.futur_kyc_privat_us_tin}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							style={{marginTop: "10px", maxWidth: "300px"}}
						/>
					)}
				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) => {
		return value.length > 0;
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};

	_onSelectChange = (option, index) => {
		CobHelpers.onViewFieldChange.call(this, "futur_kyc_privat_tax_residency_country", option.value);
	};

	_onOptionsListChange = ({type, name}, option, index) => {
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions,
				},
			},
		}, () => fulfillmentCheck(this.props, this.state));
	};
}

function _getFields() {
	return [
		"futur_kyc_privat_source",
		"futur_kyc_privat_source_other",
		"futur_kyc_privat_tax_residency_country",
		"futur_kyc_privat_is_foreign",
		"futur_kyc_privat_us_tin",
		"radio_customer_pep",
		"radio_customer_fatca",
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};

	return {
		validFields: {},
		fields: {
			futur_kyc_privat_source: {
				options: [
					{label: "Lön / Pension", value: "SalaryOrPension", checked: false},
					{label: "Sparande / Placering", value: "Savings", checked: false},
					{label: "Bolagsförsäljning", value: "CorporationSale", checked: false},
					{label: "Arv / Gåva", value: "HeritageOrGift", checked: false},
					{label: "Fastighetsförsäljning", value: "PropertySale", checked: false},
					{label: "Annat", value: "Other", checked: false}
				]
			},
			futur_kyc_privat_source_other: "",
			futur_kyc_privat_tax_residency_country: "",
			futur_kyc_privat_us_tin: "",

			futur_kyc_privat_is_foreign: {
				options: [
					{label: "Nej", value: "nej", checked: false},
					{label: "Ja", value: "ja", checked: false}
				]
			},

			radio_customer_pep: {
				options: [
					{label: "Nej", value: "no", checked: false},
					{label: "Ja", value: "yes", checked: false}
				]
			},

			radio_customer_fatca: {
				options: [
					{label: "Nej", value: "no", checked: false},
					{label: "Ja", value: "yes", checked: false}
				]
			},
		}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/KycPrivatperson/KycPrivatperson.js